import FAQ from '@/components/pageComponents/salesPage/FAQ';
import LogoIcon from '@/components/global/LogoIcon';

import { richTextComponent } from '@/sanity/sanityPortableText';
import { PortableText } from 'next-sanity';
import Link from 'next/link';
import { PortableTextBlock } from 'sanity';

export default function FAQSection({
  title,
  faqs,
}: {
  title: PortableTextBlock[];
  faqs?: {
    title?: string;
    texts?: {
      content: PortableTextBlock[];
    }[];
  }[];
}) {
  return (
    <section id="faq-details-section" className="lg:py-[22.5rem] pt-0 pb-[15.87rem] bg-white">
      <div className="container max-w-[167.5rem] flex flex-col gap-[8rem] lg:gap-[12rem]">
        {title && (
          <div className="w-[min(73.375rem,100%)] uppercase text-black flex items-center justify-between prose-em:font-[300] prose-headings:text-[6rem] prose-headings:leading-[120%]">
              <PortableText value={title} components={richTextComponent} />
          </div>
        )}

        <FAQ faqs={faqs} />
      </div>
    </section>
  );
}
